import React from "react";
import useTranslationJobDashboard from "../useTranslationJobDashboard.js";
import useShowLoader from "../../common/loading-widgets/useShowLoader.js";
import useMutationJobAlertUpdate from "../mutate/useMutationJobAlertUpdate.js";
import Alert from "@mui/material/Alert";
import Container from "react-bootstrap/Container";
import "./JobDashboardAlertsListItems.scss";
import useErrorModal from "../../common/modals/useErrorModal.js";
import useServerErrorFormatter from "../../common/modals/useServerErrorFormatter.js";
import TypeUtils from "../../../utils/TypeUtils.js";

export default function JobDashboardAlertsListItems(props) {
  const { items: alerts } = props;

  const { mutate, errors: errorsUpdateErrors } = useMutationJobAlertUpdate();

  const { t, loading: tLoading } = useTranslationJobDashboard();
  useShowLoader(tLoading, "JobDashboardAlertsListItems");

  const errorMsg = useServerErrorFormatter(errorsUpdateErrors);

  const { ErrorModal, show: showErrorModal } = useErrorModal(
    <>
      <p>{t("job-dashboard:job_dashboard_alert_update_error")}</p>
      {errorMsg}
    </>
  );

  const emptyMsg = t("job-dashboard:job_dashboard_empty_alerts_list_msg");

  const onClose = (id) => {
    const variables = {};
    variables["id"] = id;
    variables["status"] = "VIEWED";
    mutate({ variables }).catch((/*error*/) => {
      showErrorModal();
    });
  };

  return (
    <>
      {ErrorModal}
      <Container className="JobDashboardAlertsListItems spaced-children">
        {TypeUtils.arrayIsEmpty(alerts) && (
          <span className={"empty-message"}>{emptyMsg}</span>
        )}
        {alerts.map((alert, i) => (
          <Alert
            key={i}
            className="alert-col"
            variant="filled"
            severity={alert.alertType.toLowerCase()}
            onClose={() => {
              onClose(alert._id);
            }}
          >
            {alert.message}
          </Alert>
        ))}
      </Container>
    </>
  );
}
